import React, { useEffect } from "react";
import { Box, Button, TextField, Checkbox, FormControlLabel, Typography, CardContent, Card } from "@mui/material";
import { useUserProfile } from "../../hooks/useUserProfile";

const ClaimForm = ({ formData, onInputChange, onBack, onSubmit, isMobile }) => {
  // Use the hook instead of context
  const { displayName: profileDisplayName, email: profileEmail } = useUserProfile();
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    console.log("ClaimForm - Profile Hook Data:", { profileDisplayName, profileEmail });
    console.log("ClaimForm - Current formData:", formData);
    
    // Auto-populate with user profile data from hook
    if (!formData.fullName && profileDisplayName) {
      console.log("Auto-populating fullName:", profileDisplayName);
      onInputChange('fullName')({ target: { value: profileDisplayName } });
    }
    if (!formData.email && profileEmail) {
      console.log("Auto-populating email:", profileEmail);
      onInputChange('email')({ target: { value: profileEmail } });
    }
  }, [profileDisplayName, profileEmail, formData.fullName, formData.email, onInputChange]);
  
  // Use profile context data for display
  const autofillFullName = formData.fullName || profileDisplayName || "";
  const autofillEmail = formData.email || profileEmail || "";
  return (
    <Card
      sx={{
        position: "absolute",
        width: "100%",
        height: "100%",
        backfaceVisibility: "hidden",
        transform: "rotateY(180deg)",
        top: 0,
        left: 0,
        borderRadius: "24px",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
        bgcolor: "#FFFFFF",
        border: "1px solid #E8F3E0",
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <CardContent sx={{ p: 4, flex: 1, overflowY: 'auto', minHeight: 0 }}>
        <Box component="form" sx={{ display: 'grid', gap: 3 }}>
          <TextField
            label="Full Name"
            variant="outlined"
            value={autofillFullName}
            onChange={onInputChange('fullName')}
            fullWidth
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
                '&:hover fieldset': {
                  borderColor: '#516d4f',
                },
              },
              '& .MuiOutlinedInput-input': {
                color: '#2e4630',
              },
              '& .MuiInputLabel-root': {
                color: '#516d4f',
              },
            }}
          />
          <TextField
            label="Email Address"
            variant="outlined"
            type="email"
            value={autofillEmail}
            onChange={onInputChange('email')}
            fullWidth
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
                '&:hover fieldset': {
                  borderColor: '#516d4f',
                },
              },
            }}
          />
          <TextField
            label="Contact Number"
            variant="outlined"
            value={formData.contactNumber}
            onChange={onInputChange('contactNumber')}
            fullWidth
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
                '&:hover fieldset': {
                  borderColor: '#516d4f',
                },
              },
            }}
          />
          <TextField
            label="Describe your item"
            variant="outlined"
            multiline
            rows={4}
            value={formData.description}
            onChange={onInputChange('description')}
            fullWidth
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
                '&:hover fieldset': {
                  borderColor: '#516d4f',
                },
              },
            }}
          />
          <TextField
            label="Additional Notes"
            variant="outlined"
            multiline
            rows={3}
            value={formData.additionalNotes}
            onChange={onInputChange('additionalNotes')}
            fullWidth
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
                '&:hover fieldset': {
                  borderColor: '#516d4f',
                },
              },
            }}
          />
          <FormControlLabel
            control={
              <Checkbox 
                checked={formData.consent}
                onChange={onInputChange('consent')}
                sx={{
                  color: '#516d4f',
                  '&.Mui-checked': {
                    color: '#344b35',
                  },
                }}
              />
            }
            label={
              <Typography sx={{ color: '#516d4f', fontSize: '14px' }}>
                I consent to the processing of my personal information for the purpose of claiming this item
              </Typography>
            }
          />
        </Box>
      </CardContent>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', p: 3, borderTop: '1px solid #E8F3E0', bgcolor: '#fff' }}>
        <Button
          variant="outlined"
          onClick={onBack}
          sx={{
            borderColor: '#516d4f',
            color: '#516d4f',
            borderRadius: '12px',
            px: 4,
            py: 1.5,
            textTransform: 'none',
            fontFamily: 'Poppins, Helvetica',
            '&:hover': {
              borderColor: '#344b35',
              bgcolor: 'rgba(81, 109, 79, 0.05)',
            },
          }}
        >
          Back
        </Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={!formData.consent}
          sx={{
            bgcolor: '#344b35',
            color: '#ffffff',
            borderRadius: '12px',
            px: 4,
            py: 1.5,
            textTransform: 'none',
            fontFamily: 'Poppins, Helvetica',
            '&:hover': {
              bgcolor: '#2a3c2a',
            },
            '&.Mui-disabled': {
              bgcolor: '#cccccc',
            },
          }}
        >
          Submit Claim
        </Button>
      </Box>
    </Card>
  );
};

export default ClaimForm;